import smsNoDataImg from "../../assets/icons/sms-transparent.webp";
import DashboardGraphEmptyState from "../Common/DashboardGraphEmptyState";

export { hasNumericSeriesData } from "../Common/DashboardGraphEmptyState";

export default function ReportEmptyState({ title, ...props }) {
  return (
    <DashboardGraphEmptyState
      imageSrc={smsNoDataImg}
      title={title}
      {...props}
    />
  );
}
